module.exports = __webpack_public_path__ + "202408221624/img/3.284ca9ad.jpg";